module.exports = __webpack_public_path__ + "img/409e24c.jpg";